import React, { useState } from 'react';
import { motion } from 'framer-motion';
import EmojiOption from './EmojiOption';

const FeedbackScreen = ({ onEmojiSelect }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [clickedRating, setClickedRating] = useState(null);

  const emojis = [
    { gif: '/Emojis/happy.gif', label: 'Very Satisfied', rating: 'very-satisfied' },
    { gif: '/Emojis/neutral.gif', label: 'Not Sure', rating: 'neutral' },
    { gif: '/Emojis/sad.gif', label: 'Sad', rating: 'dissatisfied' },
    { gif: '/Emojis/angry.gif', label: 'Angry', rating: 'very-dissatisfied' }
  ];

  const handleEmojiClick = (rating) => {
    if (isAnimating) return;
    
    setClickedRating(rating);
    setIsAnimating(true);
    
    // Delay the callback to allow animations to complete
    setTimeout(() => {
      onEmojiSelect(rating);
    }, 1500);
  };

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    },
    exit: { 
      opacity: 0, 
      y: -20,
      transition: { duration: 0.3 }
    }
  };

  const titleVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.6, delay: 0.2 }
    }
  };

  return (
    <motion.div 
      className="feedback-screen"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <motion.h1 
        className="title feedback-title"
        variants={titleVariants}
      >
        How satisfied are you with your visit?
      </motion.h1>
      
      <motion.div 
        className="emoji-container"
        variants={containerVariants}
      >
        {emojis.map((emojiData, index) => (
          <EmojiOption
            key={emojiData.rating}
            gif={emojiData.gif}
            label={emojiData.label}
            rating={emojiData.rating}
            onClick={() => handleEmojiClick(emojiData.rating)}
            isAnimating={isAnimating}
            clickedRating={clickedRating}
            delay={index * 0.1}
          />
        ))}
      </motion.div>
    </motion.div>
  );
};

export default FeedbackScreen;
